import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "door-tag" }
const _hoisted_2 = { class: "door-headline" }
const _hoisted_3 = { class: "door-desc text-medium-emphasis" }
const _hoisted_4 = { class: "door-action" }
const _hoisted_5 = {
  key: 0,
  class: "door-fineprint text-disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "door",
    color: "background",
    rounded: "lg",
    variant: "flat",
    ripple: false,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('activate', _ctx.door.id)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          icon: _ctx.door.tagIcon,
          size: "14"
        }, null, 8, ["icon"]),
        _createTextVNode(" " + _toDisplayString(_ctx.door.tag), 1)
      ]),
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.door.headline), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.door.desc), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_ctx.door.action), 1),
        _createVNode(_component_v_icon, {
          icon: "mdi-arrow-right",
          size: "18",
          class: "door-arrow"
        }),
        (_ctx.door.fineprint)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.door.fineprint), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}